import { combineReducers } from '@reduxjs/toolkit';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import autoMergeLevel2 from 'redux-persist/lib/stateReconciler/autoMergeLevel2';

import authReducer from './reducers/auth';
import commonReducer from './reducers/common';
import dataValidationReducer from './reducers/dataValidation';
import reducerTypes from './reducerTypes';

const reducers = {};

const dataValidationPersistConfig = {
  key: 'dataValidation',
  storage,
  stateReconciler: autoMergeLevel2,
  whitelist: ['dataValidationTableFilters', 'entryDetailsTableFilters'],
};

reducers[reducerTypes.auth] = authReducer;
reducers[reducerTypes.common] = commonReducer;
reducers[reducerTypes.dataValidation] = persistReducer(
  dataValidationPersistConfig,
  dataValidationReducer,
);

const appReducer = combineReducers(reducers);

const rootReducer = (state, action) => {
  if (action.type === 'AUTH/SET_LOGOUT') {
    localStorage.removeItem('persist:authLicese');
  }
  return appReducer(state, action);
};

export default rootReducer;
